import React from 'react';
import {View} from 'react-native';
import SingleHeader from 'design-system/src/Widget/SingleHeader/SingleHeader.web';
import RelatedCategory from '@src/components/RelatedCategory/RelatedCategory';
import ShareDialog from 'design-system/src/Components/Dialog/ShareDialog/ShareDialog';
import ContentEmpty from 'design-system/src/Components/ContentEmpty/ContentEmpty';
import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';
import {SingleContentLoader} from 'design-system/src/Components/ContentLoader';

interface VodSingleContentProps {
  vodItem?: IVodItemFragmentFragment;
  listCategory: string[];
  bookmarkItem?: any;
  loading: boolean;
  isMobile: boolean;
  calculateWidth: () => number;
  t: (key: string) => string;
  onWatchClick: (item: IVodItemFragmentFragment) => () => void;
  openTrailer: (item: IVodItemFragmentFragment) => () => void;
  updateBookMark: (value: boolean) => void;
  shareContent: () => void;
  isOpenDialogShare: boolean;
  setIsOpenDialogShare: (open: boolean) => void;
  linkToShare?: string;
  setLinkToShare: (link: string) => void;
}

const VodSingleContent: React.FC<VodSingleContentProps> = ({
  vodItem,
  listCategory,
  bookmarkItem,
  loading,
  isMobile,
  calculateWidth,
  t,
  onWatchClick,
  openTrailer,
  updateBookMark,
  shareContent,
  isOpenDialogShare,
  setIsOpenDialogShare,
  linkToShare,
}) => {
  return (
    <div>
      {loading ? (
        <SingleContentLoader />
      ) : vodItem ? (
        <div>
          <SingleHeader
            text={vodItem?.description || ''}
            listCategory={listCategory}
            variant="vod"
            image={
              vodItem && vodItem.thumbnail && vodItem.thumbnail.url
                ? {uri: vodItem.thumbnail.url}
                : undefined
            }
            title={vodItem?.title || ''}
            buttonTitle={t('Watch') || ''}
            seeMoreLabel={t('See more') + ''}
            seeLessLabel={t('See less') + ''}
            trailerLabel={t('Trailer') + ''}
            favoriLabel={t('Favoris') + ''}
            shareLabel={t('Share') + ''}
            onPressButton={onWatchClick(vodItem)}
            isTrailer={!!vodItem && !!vodItem.trailer}
            isLiked={!!bookmarkItem}
            onClickPlay={
              (!!vodItem && !!vodItem.trailer && openTrailer(vodItem)) ||
              undefined
            }
            onClickFav={updateBookMark}
            onClickShare={shareContent}
          />
          <View
            style={{
              marginTop: isMobile ? 26 : 56,
              width: calculateWidth(),
            }}>
            {!!vodItem && vodItem.id && <RelatedCategory id={vodItem.id} />}
          </View>
          <ShareDialog
            isOpen={isOpenDialogShare}
            onClose={() => setIsOpenDialogShare(false)}
            link={linkToShare}
          />
        </div>
      ) : (
        <ContentEmpty title={t('Content not available in your region')} />
      )}
    </div>
  );
};

export default VodSingleContent;
